import { Component, OnInit, Input } from '@angular/core';
import { HelpUrl as url } from './help-url.enum';
import { HelpText as text } from './help-text.enum';
import { environment as envConst } from '../../../environments/environment';
import { WhitelabelService } from '../whitelabel.service';

@Component({
  selector: 'app-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss'],
})
export class HelpIconComponent implements OnInit {
  @Input() helpPageName: string;

  pageUrl: string;
  displayText: string;
  showHelpCenterIcon: boolean;
  constructor(private whitelabelService: WhitelabelService) {}

  ngOnInit() {
    if (!this.helpPageName || !url[this.helpPageName as keyof typeof url]) {
      this.showHelpCenterIcon = false;
      return;
    }
    if (this.helpPageName === 'menuPartner') {
      this.pageUrl = `${envConst.hostURL}partner`;
    } else {
      this.pageUrl = `${envConst.helpHostURL}${url[this.helpPageName]}`;
    }
    this.displayText = text[this.helpPageName];
    this.showHelpCenterIcon =
      this.whitelabelService.getWhiteLabelShowHelpCenterIcon();
  }
}
